import React, { PropsWithChildren } from 'react';

interface PageProps {
  title: string;
}

const Page: React.FC<PropsWithChildren<PageProps>> = ({ title, children }) => (
  <section className="vl-region">
    <div className="vl-layout">
      <h2 className="vl-title vl-title--h2" data-cy="page-title">
        {title}
      </h2>
      {children}
    </div>
  </section>
);

export default Page;
